import { render } from "./Punjab.vue?vue&type=template&id=4f53ddac&scoped=true"
const script = {}

import "./Punjab.vue?vue&type=style&index=0&id=4f53ddac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f53ddac"]])

export default __exports__